document.addEventListener('DOMContentLoaded', () => {
    let searchBars = document.querySelectorAll('.search-trigger');
    let resultsWrapper = document.querySelector('.predictive-search-container')
    let resultsContainer = resultsWrapper.querySelector('.inner');

    // console.log("SEARCH")

    searchBars.forEach(searchBar => {
    
        // Site search using predictive search api
        const predictiveSearchCallBack = () => {
            const section_name = 've-predictive-search';

            if(searchBar.value.length > 2){
                
                var requestResponse;
                console.log('Loading...');
                fetch(`/search/suggest?q=${searchBar.value}&resources[type]=product,collection,page&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=product_type,title,variants.barcode,variants.sku,variants.title,vendor&section_id=${section_name}`)
                .then((response) => {
                    requestResponse = response;
                    return response.text();
                })
                .then((text) => {
                    if (!requestResponse.ok) {
                    throw new Error(`${requestResponse.status}: ${text}`);
                    }
                    resultsWrapper.classList.add('active');

                    const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector(`#shopify-section-${section_name}`).innerHTML;
                    
                    console.log('Search results loaded');
                    resultsContainer.innerHTML = resultsMarkup;

                    // View all products link submit search form

                    const view_btn = resultsWrapper.querySelector("#view-products");
                    const search_form = document.querySelector(".mega-menu-wrapper .search-bar-qf");
                    const search_mobile = document.querySelector(".header-search-mobile .search-bar-qf");
                    console.log("🚀 ~ file: predictive-search.js:41 ~ .then ~ search_mobile:", search_mobile)

                    if (view_btn) {
                        view_btn.addEventListener('click', () => {
                            if (window.innerWidth < 992) {
                                search_mobile.submit();
                            } else {
                                search_form.submit();
                            }

                        })
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
            } else {
                resultsContainer.innerHTML = '';
                resultsWrapper.classList.remove('active');
            }
        }
    
        let searchMethod = predictiveSearchCallBack;

        if(searchBar && resultsContainer){
            // debounce searchMethod
            let timeoutId;
            function debounceSearch() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(searchMethod, 200);
            }
            searchBar.addEventListener('keyup', debounceSearch);

            // close search
            let closeButton = resultsWrapper.querySelector('.close');
            closeButton.addEventListener('click', () => {
                resultsWrapper.classList.remove('active');
            })
        }
    })
    
})